<itl-wizard-page
  [isSinglePage]="true"
  pageTitleTransPath="kim.send.title"
  [pageIsValid]="pageIsValid"
  doneIcon="alberta-paperplane-solid"
  (cancelClicked)="cancel()"
  (doneClicked)="send()"
>
  <itl-loading-indicator *ngIf="sending" [delay]="0"></itl-loading-indicator>
  <div *ngIf="!sending">
    <itl-input-button-template
      [value]="'kim.send.correspondenceType_kim' | translate"
      [title]="'kim.send.correspondenceType' | translate"
      icon="alberta-contact-data"
      [disabled]="true"
    ></itl-input-button-template>

    <itl-info-box *ngIf="noKimAddress" [type]="infoBoxTypeWarning" data-testid="kim-no-address-info">
      {{ 'kim.send.noKimAddress' | translate }}
    </itl-info-box>

    <ng-container *ngIf="!noKimAddress">
      <itl-selection
        [formControl]="senderControl"
        [title]="'kim.send.sender' | translate"
        [placeholder]="'kim.send.sender_placeholder' | translate"
        [values]="senderSelectionItems"
        [required]="true"
        [noDeleteButton]="true"
        [disabled]="senderControl.disabled"
        icon="alberta-person"
        data-testid="kim-sender-select"
      ></itl-selection>

      <itl-input-button-template
        *ngIf="!vzdUnavailable"
        [control]="recipientControl"
        [hasErrors]="recipientControl.invalid && recipientControl.touched"
        [value]="recipient?.displayName"
        [title]="'kim.send.recipient' | translate"
        [placeholder]="'kim.send.recipient_placeholder' | translate"
        [required]="true"
        icon="alberta-person"
        data-testid="kim-recipient-input"
        (buttonPressed)="openRecipientSearch()"
      >
        <div
          class="deleteButton"
          *ngIf="recipient"
          (click)="removeRecipient($event)"
          data-testid="kim-recipient-remove"
        >
          <ion-icon name="alberta-delete"></ion-icon>
        </div>
      </itl-input-button-template>

      <itl-info-box *ngIf="vzdUnavailable" [type]="infoBoxTypeWarning" data-testid="kim-vzd-unavailable-info">
        <div class="vzd-unavailable">
          <div>{{ 'kim.send.vzdUnavailable' | translate }}</div>
          <div class="btn-wrapper">
            <div class="btn warning bold" tappable (click)="retryVzd()" data-testid="kim-vzd-retry">
              <itl-alberta-icon class="icon" name="alberta-refresh"></itl-alberta-icon
              ><span class="text">{{ 'kim.send.retry' | translate }}</span>
            </div>
          </div>
        </div>
      </itl-info-box>
    </ng-container>
  </div>
</itl-wizard-page>
